import '../styles/tailwind.css'
import '../styles/admin.css'
import '../styles/scss/main.scss'
import initButtonEffect from './buttonEffect'
import initPreferences from './preferences'
import initCookie from './setCookie'
import Cookies from 'js-cookie'
import initDatalayer from './dataLayer'

const isCookieActive = (): boolean => !!Cookies.get('CookieConsent')
const cookieTimeout = 3000

document.addEventListener('DOMContentLoaded', (): void => {
  setTimeout(() => {
    const wrapper = document.querySelector('.cookiebanner') as HTMLElement
    const buttonEffect = document.querySelector('.cookiebanner__button--cookie-effect') as HTMLElement
    const overlay = document.querySelector('.cookiebanner--popout__container') as HTMLElement

    if (isCookieActive() === true) {
      wrapper.remove()
      initDatalayer(JSON.parse(Cookies.get('CookieConsent')))

      if (overlay !== null) {
        overlay.remove()
      }

      return
    }

    wrapper.classList.add('active')

    if (buttonEffect !== null) {
      initButtonEffect()
    }

    initPreferences()
    initCookie()
  }, cookieTimeout)
})
